import { authHeaders } from '@/utils/authToken';
import type { VehicleLocation } from '@/types';

export const vehicleService = {
  async list(): Promise<VehicleLocation[]> {
    const res = await fetch('/api/vehicles', { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async get(id: string): Promise<VehicleLocation> {
    const res = await fetch(`/api/vehicles/${id}`, { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async create(vehicle: Partial<VehicleLocation>): Promise<VehicleLocation> {
    const res = await fetch('/api/vehicles', {
      method: 'POST',
      headers: await authHeaders(),
      body: JSON.stringify(vehicle),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async update(id: string, updates: Partial<VehicleLocation>): Promise<VehicleLocation> {
    const res = await fetch(`/api/vehicles/${id}`, {
      method: 'PUT',
      headers: await authHeaders(),
      body: JSON.stringify(updates),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async remove(id: string): Promise<void> {
    const res = await fetch(`/api/vehicles/${id}`, {
      method: 'DELETE',
      headers: await authHeaders(),
    });
    if (!res.ok) {
      const json = await res.json();
      throw new Error(json.error);
    }
  },

  async getLocation(vehicleId: string): Promise<VehicleLocation[]> {
    const res = await fetch(`/api/vehicles/${vehicleId}/location`, { headers: await authHeaders() });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },

  async setLocation(vehicleId: string, location: Partial<VehicleLocation>): Promise<VehicleLocation> {
    const res = await fetch(`/api/vehicles/${vehicleId}/location`, {
      method: 'PUT',
      headers: await authHeaders(),
      body: JSON.stringify(location),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.error);
    return json.data;
  },
};
